import { render, staticRenderFns } from "./tidakBekerja.vue?vue&type=template&id=ef5490fe&"
import script from "./tidakBekerja.vue?vue&type=script&lang=js&"
export * from "./tidakBekerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports